import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=3b29c1bb&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=ts"
export * from "./BottomBar.vue?vue&type=script&lang=ts"
import style0 from "./BottomBar.vue?vue&type=style&index=0&id=3b29c1bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29c1bb",
  null
  
)

export default component.exports